import { render, staticRenderFns } from "./myCommunity.vue?vue&type=template&id=43ca2276&scoped=true"
import script from "./myCommunity.vue?vue&type=script&lang=js"
export * from "./myCommunity.vue?vue&type=script&lang=js"
import style0 from "./myCommunity.vue?vue&type=style&index=0&id=43ca2276&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ca2276",
  null
  
)

export default component.exports